export function overrideDefaultAuthorizationHeaderName(newAuthHeader: string) {
  window.fetch = new Proxy(window.fetch, {
    apply: (target, that, args) => {
      try {
        if (typeof args[0] === 'object' && args[0] instanceof Request) {
          const request: Request = args[0]
          if (request.headers.has('Authorization') && request.url.includes(document.location.host)) {
            const authHeader = request.headers.get('Authorization') || ''
            request.headers.delete('Authorization')
            request.headers.set(newAuthHeader, authHeader)
          }
        } else if (typeof args[0] === 'string') {
          const url = args[0]
          const urlWithoutProtocol = url.replace(/^(https?:)?\/\//, '')
          if (url.startsWith('/') || urlWithoutProtocol.startsWith(document.location.host)) {
            if (args[1].headers && args[1].headers['Authorization']) {
              const { ['Authorization']: authHeader, ...headers } = args[1].headers
              args[1].headers = { [newAuthHeader]: authHeader, ...headers }
            }
          }
        }

        return target.apply(that, args as never)
      } catch (error) {
        console.error('Error changing Authorization header', error)
        return target.apply(that, args as never)
      }
    }
  })
}
